/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');

var GetEntitySiteRecordkeepingByHistorySnapshot = require('../services/GetEntitySiteRecordkeepingByHistorySnapshot');

var NonDepEntitySiteRecordkeepingSnapshotView = require('../views/NonDepEntitySiteRecordkeepingSnapshotView');

module.exports = function(entityId, historySnapshotId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(
    GetEntityIdentifiers(entityId),
    GetEntitySiteRecordkeepingByHistorySnapshot(historySnapshotId)
  )
    .done(function(entityIdentifiers, entitySiteRecordkeepings) {
      NavUtils.navigate('nondep/entity/' + entityId + '/recordkeeping-history/' + historySnapshotId);
      Scaffold.content.show(
        new NonDepEntitySiteRecordkeepingSnapshotView({
          model: new Backbone.Model({
            entityIdentifiers: entityIdentifiers,
            entitySiteRecordkeepings: entitySiteRecordkeepings
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
